import styled from 'styled-components';
import {BGImageCenter, dFlex, dFlexCenter} from '../../../../../globalVariables/GlobalVariables';
import {tokens} from '@tickchak/react-share/app';

export const lecturersPlaceholder = styled.div`
    height: 28px;
`;

export const lecturerRow = styled.div`
    ${dFlex}
    align-items: center;
    gap: 4px;
`;

export const lecturerName = styled.div`
    font-size: ${tokens.typography.fontSize.caption};
    font-weight: ${tokens.typography.fontWeight.regular};
    line-height: ${tokens.typography.lineHeight.caption};
    color: var(--TA-color-text-default);
    text-align: start;
`;

export const avatarsRow = styled.div`
    ${dFlex}
    align-items: center;
`;

export const avatar = styled.div<{ $image?: string | null }>`
    width: 28px;
    height: 28px;
    border-radius: 50%;
    flex-shrink: 0;
    border: 1px solid #ECEEF0;
    ${p => BGImageCenter(p.$image, 'cover')}
    &:not(:first-child) {
        margin-inline-start: calc(-1 * ${tokens.spacing.spaceXs});
    }
`;

export const overflowBadge = styled.div`
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: var(--TA-color-bg-base);
    border: 1px solid var(--TA-color-border-subtle);
    ${dFlexCenter}
    font-weight: ${tokens.typography.fontWeight.bold};
    font-size: ${tokens.typography.fontSize.caption};
    color: var(--TA-color-text-default);
    flex-shrink: 0;
    margin-inline-start: calc(-1 * ${tokens.spacing.spaceXs});
`;
